import React from 'react';
import { Hero } from '../components/Hero';
import { Logos } from '../components/Logos';
import { Problem } from '../components/Problem';
import { CastingCalls } from '../components/CastingCalls';
import { RosterDatabase } from '../components/RosterDatabase';
import { Audiences } from '../components/Audiences';
import { ProductWorkflow } from '../components/ProductWorkflow';
import { Moat } from '../components/Moat';
import { CTA } from '../components/CTA';
import { InfluencerHub, CapterraReviews, Newsletter, CreatorAssetOS } from '../components/HomeExtras';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
export const Home = () => {
  return <>
      <Hero data-id="element-2043" />
      <Logos data-id="element-2044" />
      <Problem data-id="element-2045" />
      <CastingCalls data-id="element-2046" />
      <RosterDatabase data-id="element-2047" />
      <Audiences data-id="element-2048" />
      <ProductWorkflow data-id="element-2049" />
      <Moat data-id="element-2050" />
      <Testimonials title="Loved by top brands and agencies" items={BRAND_TESTIMONIALS} data-id="element-2051" />
      <InfluencerHub data-id="element-2052" />
      <CapterraReviews data-id="element-2053" />
      <CreatorAssetOS data-id="element-2054" />
      <CTA data-id="element-2055" />
      <Newsletter data-id="element-2056" />
    </>;
};